import React from "react";
import { Link } from "react-router-dom";
import { translations } from "../translations";
import { useLanguage } from "../context/LanguageContext";

const Footer = () => {
  const { lang } = useLanguage();
  const t = translations[lang];

  return (
    <footer className="bg-footer text-white/85">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-3">
          <span className="font-serif text-3xl font-bold text-white leading-none italic">
            {t.brand.logoMain[0]}
          </span>
          <div className="leading-tight border-l border-white/25 pl-3">
            <div className="font-serif text-lg font-bold text-white tracking-wide">
              {t.brand.logoMain} <span className="text-sky-accent">{t.brand.logoSub}</span>
            </div>
            <div className="text-[8px] tracking-[0.24em] uppercase text-white/50 mt-0.5">
              {t.brand.accountants}
            </div>
          </div>
        </Link>

        <p className="text-sm text-white/70 text-center">
          Copyright &copy; {new Date().getFullYear()} {t.brand.legal}
        </p>

        <div className="flex items-center gap-6 text-sm">
          <a href="#" className="hover:text-white transition-colors">{t.footer.terms}</a>
          <a href="#" className="hover:text-white transition-colors">{t.footer.privacy}</a>
          <a href="#" className="hover:text-white transition-colors">{t.footer.disclaimer}</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
